<div class="card card-transaction">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4 class="card-title">{{ "MINE_REFUND" | translate }}</h4>
    <a *ngIf="refund_list && refund_list.length > 0" routerLink="/dashboard/my-refunds">{{ "VIEW_ALL" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="refund_list && refund_list.length > 0; else noRefund">
      <div class="mb-1" *ngFor="let item of refund_list">
        <div class="refund-item" [ngbTooltip]="item.enabled_label | translate" placement="left">
          <div [ngClass]="{
          'bg-warning': item.status === 0,
          'bg-success': item.status === 1,
          'bg-danger': item.status === 2
          }"></div>
          <div>
            <a class="font-weight-medium text-break-line-1" [routerLink]="'/dashboard/my-refunds'" [queryParams]="{ id: item.id }">{{ "REFUND" | translate }} {{ item.amount }}€</a>
            <small>{{ item.request_date | date:'dd/MM/yyyy' }}</small>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noRefund>{{ "NOT_ONE_REFUND" | translate }}</ng-template>
    <div>
      <button class="mt-1 btn btn-md btn-outline-primary" (click)="showModal = true">{{ "REQUIRE_REFUND" | translate }}</button>
    </div>
  </div>
</div>
<app-request-refund-modal *ngIf="showModal" (onClose)="callbackFn.emit(); showModal = false;"></app-request-refund-modal>